<template>
  <div class="visit-quick-info">
    <div v-if="visit && !showTherapistInfo && !loading" class="visit-details">
      <div class="patient-info">
        <h3>{{ visit.patientName }}</h3>
      </div>
      
      <div class="visit-time">
        <p><strong>Data i godzina:</strong> {{ formatDateTime(visit.dateTime) }}</p>
      </div>
      
      <div class="service-info">
        <p><strong>Typ usługi:</strong> {{ visit.serviceType }}</p>
      </div>
      
      <div class="payment-status">
        <p><strong>Status płatności:</strong> 
          <span :class="{ 'paid': visit.isPaid, 'unpaid': !visit.isPaid, 'payu': visit.isPayu }">
            {{ visit.isPaid ? 'Opłacona' : 'Nieopłacona' }}
            <span v-if="visit.isPayu" class="payu-icon">PAYU</span>
          </span>
        </p>
      </div>
      
      <div class="visit-notes" v-if="visit.notes">        
        <p><strong>Notatka:</strong></p>
        <tiptap-vuetify v-model="visit.notes"  name="notes"
                          readonly id="notes" />
      </div>
    </div>
    <div v-else-if="showTherapistInfo && !loading && visit">
      <div class="service-info" v-if="visit.recognition">
        <p><strong>Rozpoznanie:</strong> <span v-html="visit.recognition"></span></p>
      </div>
      <div class="service-info" v-if="visit.process">
        <p><strong>Przebieg:</strong> <span v-html="visit.process"></span></p>
      </div>      
      <div class="service-info" v-if="visit.recommendations">
        <p><strong>Zalecenia:</strong> <span v-html="visit.recommendations"></span></p>
      </div>      
      <div class="service-info">
        <p><strong>Typ usługi:</strong> {{ visit.serviceType }}</p>
      </div>
      <div class="service-info" v-if="visit.proceduresString">
        <p><strong>ICD9:</strong> {{ visit.proceduresString }}</p>
      </div>
      <div class="visit-notes" v-if="visit.notes">        
        <p><strong>Notatka:</strong></p>
        <tiptap-vuetify v-model="visit.notes"  name="notes"
                          readonly id="notes" />
      </div>
      <div class="visit-notes" v-if="visit.notesForReception">        
        <p><strong>Notatka dla recepcji:</strong></p>
        <tiptap-vuetify v-model="visit.notesForReception"  name="notesForReception"
                          readonly id="notes" />
      </div>      
    </div>
    <div v-else class="loading">
      Ładowanie informacji o wizycie...
    </div>
  </div>

</template>

<script>
import { visitService } from "@/services/";
import swal from "sweetalert";
import { TiptapVuetify, } from 'tiptap-vuetify'
export default {
  name: 'VisitQuickInfo',
  components: {TiptapVuetify},
  props: {
    visitId: {
      type: [String, Number],
      required: true
    },
    typywizyt: {
      type: Array,
      required: true
    },
    showTherapistInfo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visit: null,
      loading: false
    }
  },
  methods: {
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then( () => {
        this.loading = false;
      });
    },
    async fetchVisitData() {
      try {
        // TODO: Replace with actual API call
        // const response = await this.$api.visits.getVisit(this.visitId)
        // this.visit = response.data
        
        // Temporary mock data for testing

        this.loading = true;
        const details = await visitService.GetPatientVisitDetails(this.visitId)
        let serviceType = '';
        let isPayu = false;
        if(details != null && details.data != null && details.data.result != null) {          
          if(details.data.result.typWizytyTerapeutyId && details.data.result.typWizytyTerapeutyId != 0) {
            serviceType = this.typywizyt.find(x=>x.id == details.data.result.typWizytyTerapeutyId).nazwa;
          }                
          if(details.data.result.payments && details.data.result.payments.length > 0) {
            isPayu = details.data.result.payments.find(x=>x.payUOrderId != null && x.payUOrderId != 0 && x.payURefunded == false) != null;
          }
          this.visit = {
            patientName: details.data.result.client.name + ' ' + details.data.result.client.surname,
            dateTime: details.data.result.startTime,
            serviceType: serviceType,
            isPaid: details.data.result.payments && details.data.result.payments.length > 0,
            isPayu: isPayu,
            notes: details.data.result.notes,        
            procedures: details.data.result.procedures,
            notesForReception: details.data.result.notesForReception,
            process: details.data.result.process,
            recognition: details.data.result.recognition,
            recommendations: details.data.result.recommendations,
            proceduresString: ''
          }
          if(details.data.result.procedures && details.data.result.procedures.length > 0) {            
            this.visit.proceduresString = details.data.result.procedures.map(x=>x.icd9_code + ' - ' + x.description).join(', ');
          }
          this.loading = false;
        }
        else {
          this.loading = false;
          this.showError('Błąd podczas pobierania danych wizyty')
        }

  /*        this.visit = {
          patientName: 'Jan Kowalski',
          dateTime: new Date(),
          serviceType: 'Konsultacja',
          isPaid: true,
          notes: 'Pacjent zgłasza ból głowy...'
        }*/
      } catch (error) {
        console.log(error);
        this.showError('Błąd podczas pobierania danych wizyty')
      }
    },
    formatDateTime(dateTime) {
      if (!dateTime) return ''
      const date = new Date(dateTime)
      return new Intl.DateTimeFormat('pl-PL', {
        dateStyle: 'medium',
        timeStyle: 'short'
      }).format(date)
    }
  },
  created() {
    //this.fetchVisitData()
  },
  watch: {
    visitId: {
      handler() {
        this.fetchVisitData()
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.visit-quick-info {
  padding: 1rem;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.visit-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.patient-info h3 {
  margin: 0;
  color: #2c3e50;
}

.visit-time, .service-info, .payment-status {
  margin: 0;
}

.paid {
  color: #27ae60;
  font-weight: 500;
}

.unpaid {
  color: #e74c3c;
  font-weight: 500;
}

.notes-content {
  margin-top: 0.5rem;
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  white-space: pre-wrap;
}

.loading {
  text-align: center;
  color: #666;
  padding: 1rem;
}
.payu-icon {
  color: #27ae60;
  font-weight: 500;
}
</style>
